module.exports = __webpack_public_path__ + "static/media/ec.a12f3b49.svg";